import { Checkbox, FormControlLabel, Typography } from "@material-ui/core"
import { chartStyles } from "../../../styles"

export function DeltaCheckbox({
  checked,
  title,
  onChange,
}: {
  checked: boolean
  onChange: () => void
  title: string
}) {
  return (
    <FormControlLabel
      style={{ pointerEvents: "none" }}
      control={
        <>
          <Checkbox
            checked={checked}
            color="primary"
            style={{ pointerEvents: "all" }}
            className={chartStyles.button}
            onChange={onChange}
          />
        </>
      }
      label={
        <Typography
          className={chartStyles.drilldownLabel}
          style={{ fontWeight: 400 }}
        >
          {title}
        </Typography>
      }
    />
  )
}
